/* OnlyAttire Premium — theme.js */
(function () {
  'use strict';

  function paintCount(n) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = n;
      el.hidden = n === 0;
      el.classList.remove('bump');
      void el.offsetWidth;
      el.classList.add('bump');
    });
  }

  function refreshCart() {
    return fetch(window.Shopify.routes.root + 'cart.js')
      .then(function (r) { return r.json(); })
      .then(function (c) { paintCount(c.item_count); return c; })
      .catch(function () {});
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-add]');
    if (!btn) return;
    e.preventDefault();
    var id = btn.getAttribute('data-add');
    if (!id) return;
    var original = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding…';
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
    })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function () { btn.textContent = 'Added ✓'; btn.classList.add('done'); return refreshCart(); })
      .catch(function () { btn.textContent = 'Sold out'; })
      .finally(function () {
        setTimeout(function () {
          btn.textContent = original;
          btn.classList.remove('done');
          btn.disabled = false;
        }, 1400);
      });
  });

  document.querySelectorAll('[data-variant-form]').forEach(function (form) {
    var variants = JSON.parse(form.getAttribute('data-variants') || '[]');
    var idField = form.querySelector('[name="id"]');
    var priceEl = document.querySelector('[data-price]');
    var submit = form.querySelector('[data-submit]');

    function selected() {
      return Array.prototype.map.call(form.querySelectorAll('[data-opt]:checked'), function (i) { return i.value; });
    }

    function sync() {
      var picked = selected();
      var match = variants.find(function (v) {
        return v.options.every(function (o, i) { return o === picked[i]; });
      });
      if (!match) return;
      idField.value = match.id;
      if (priceEl && match.price_html) priceEl.innerHTML = match.price_html;
      if (submit) {
        submit.disabled = !match.available;
        submit.textContent = match.available ? 'Add to cart' : 'Sold out';
      }
      if (history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', match.id);
        history.replaceState({}, '', url.toString());
      }
    }

    form.querySelectorAll('[data-opt]').forEach(function (input) { input.addEventListener('change', sync); });
    sync();

    form.addEventListener('submit', function (e) {
      if (!form.hasAttribute('data-ajax')) return;
      e.preventDefault();
      var fd = new FormData(form);
      submit.disabled = true;
      submit.textContent = 'Adding…';
      fetch(window.Shopify.routes.root + 'cart/add.js', { method: 'POST', body: fd })
        .then(function (r) { return r.json(); })
        .then(function () { submit.textContent = 'Added ✓'; return refreshCart(); })
        .catch(function () { submit.textContent = 'Something went wrong'; })
        .finally(function () {
          setTimeout(function () { submit.textContent = 'Add to cart'; submit.disabled = false; }, 1400);
        });
    });
  });

  var mainImg = document.querySelector('[data-main-image]');
  document.querySelectorAll('[data-thumb]').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      if (!mainImg) return;
      mainImg.src = thumb.getAttribute('data-thumb');
      mainImg.srcset = '';
      document.querySelectorAll('[data-thumb]').forEach(function (t) {
        t.setAttribute('aria-current', String(t === thumb));
      });
    });
  });

  document.querySelectorAll('[data-carousel]').forEach(function (root) {
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-slide]'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-dot]'));
    var countEl = root.querySelector('[data-count]');
    var pauseBtn = root.querySelector('[data-pause]');
    if (slides.length < 2) return;

    var i = 0;
    var playing = true;
    var timer = null;
    var intervalMs = Number(root.dataset.interval || 6000);

    function show(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, idx) { s.classList.toggle('active', idx === i); });
      dots.forEach(function (d, idx) { d.classList.toggle('active', idx === i); });
      if (countEl) countEl.textContent = (i + 1) + ' / ' + slides.length;
    }

    function next() { show(i + 1); }
    function prev() { show(i - 1); }

    function start() {
      stop();
      timer = setInterval(next, intervalMs);
    }
    function stop() {
      if (timer) clearInterval(timer);
      timer = null;
    }

    root.querySelectorAll('[data-next]').forEach(function (b) { b.addEventListener('click', function () { next(); if (playing) start(); }); });
    root.querySelectorAll('[data-prev]').forEach(function (b) { b.addEventListener('click', function () { prev(); if (playing) start(); }); });
    dots.forEach(function (d, idx) { d.addEventListener('click', function () { show(idx); if (playing) start(); }); });

    if (pauseBtn) {
      pauseBtn.addEventListener('click', function () {
        playing = !playing;
        pauseBtn.setAttribute('aria-label', playing ? 'Pause slideshow' : 'Play slideshow');
        pauseBtn.innerHTML = playing
          ? '<svg viewBox="0 0 12 12"><rect x="1" y="0" width="3" height="12"/><rect x="8" y="0" width="3" height="12"/></svg>'
          : '<svg viewBox="0 0 12 12"><path d="M1 0l10 6-10 6z"/></svg>';
        if (playing) start(); else stop();
      });
    }

    show(0);
    if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) start();
  });

  var pop = document.getElementById('oa-pop');
  if (pop && !sessionStorage.getItem('oa-pop-seen')) {
    setTimeout(function () { pop.classList.add('show'); }, Number(pop.dataset.delay || 3200));
  }
  var popX = document.getElementById('oa-pop-x');
  if (popX) {
    popX.addEventListener('click', function () {
      pop.classList.remove('show');
      sessionStorage.setItem('oa-pop-seen', '1');
    });
  }

  var drawer = document.getElementById('oa-drawer');
  var burger = document.getElementById('oa-burger');
  var drawerX = document.getElementById('oa-drawer-x');
  if (burger && drawer) {
    burger.addEventListener('click', function () {
      drawer.classList.add('open');
      document.body.style.overflow = 'hidden';
    });
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('open');
    document.body.style.overflow = '';
  }
  if (drawerX) drawerX.addEventListener('click', closeDrawer);
  if (drawer) drawer.querySelectorAll('a').forEach(function (a) { a.addEventListener('click', closeDrawer); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });

  refreshCart();
})();
